import React from "react";
import { ToolRendererProps } from "./types";

export const GlobToolRenderer: React.FC<ToolRendererProps> = ({
  args,
  status,
  toolResult,
  renderWithErrorIfFailed,
  getFallbackText,
  stringifyRender,
}) => {
  const hasNewSchema = typeof args?.pattern === "string";

  if (hasNewSchema) {
    const pattern = args.pattern;
    const searchPath = args.path;

    return (
      <>
        {renderWithErrorIfFailed(
          <div className="text-xs text-secondary-n-400 space-y-1">
            <div>
              Pattern: <span className="font-mono">{pattern}</span>
            </div>
            {searchPath && (
              <div>
                Path: <span className="font-mono">{searchPath}</span>
              </div>
            )}
            {toolResult?.count !== undefined && status === "succeeded" && (
              <div className="text-secondary-n-500">
                Found {toolResult.count}{" "}
                {toolResult.count === 1 ? "file" : "files"}
              </div>
            )}
          </div>,
        )}
      </>
    );
  } else {
    let globPatterns: string[] = [];
    try {
      globPatterns = (args?.globPatterns || []).map(stringifyRender);
    } catch (e) {
      console.error(
        "Failed to stringify glob patterns:",
        e,
        args?.globPatterns,
      );
      globPatterns = [];
    }

    return globPatterns.length > 0
      ? renderWithErrorIfFailed(
          <ul className="list-none">
            {globPatterns.map((pattern: string, index: number) => (
              <li key={index} className="text-xs text-secondary-n-400">
                {pattern}
              </li>
            ))}
          </ul>,
        )
      : getFallbackText();
  }
};
